import { defineStore } from "pinia";
import { useMessage } from "./app-toast";


interface ContactStoreState {
    contactLoading: boolean;
}

export const useContactStore = defineStore("ContactStore", {
    state: (): ContactStoreState => ({
        contactLoading: false,
    }),
    actions: {
        async submitContactMessage(
            subject: string,
            message: string,
        ): Promise<void> {
            const { $api, $i18n } = useNuxtApp()
            const toast = useMessage()
            const localePath = useLocalePath()

            this.contactLoading = true;
            try {
                await $api("/feedback/contact", {
                    method: 'POST',
                    body: {
                        subject,
                        message,
                    }
                });

                toast.add(
                    $i18n.t("messages.message_sent_success"),
                    "success",
                );
                setTimeout(async () => {
                    await navigateTo(localePath('/gallery'))
                }, 2500);
            } catch (e) {
                toast.error(e);
            } finally {
                this.contactLoading = false;
            }
        },
    },
});
